document.addEventListener("DOMContentLoaded", () => {
    var recoveryModal = document.getElementById('dev-tricker-recover-account-modal');

    if (recoveryModal) {
        const passwordInput = document.querySelector('#dev-tricker-recover-account-modal input[type="password"]');
        if (passwordInput) {
            devtricker_handle_password_reset_submission();
            devtricker_handle_password_reset_with_code_submission();
        }
    }
});